module.exports = __webpack_public_path__ + "static/img/4.71d1a54.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/commonality/20251009/4.jpg
// module id = 5M64
// module chunks = 7